export type VfbElementType = 'text' | 'textarea' | 'date' | 'static' | 'list' | 'file' | 'signature' | 'object';

export type VfbElement = {
  type: VfbElementType,
  name: string,
  label?: string,
  [key: string]: any,
}

export const DateTimeValueFormatUnixTimestampSeconds: string = "X";